// General
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Login.css';
import bt from '../../../src/components/commonStyle.css';
// Components
import LoginForm from '../../components/LoginForm';
// Locale
import messages from '../../locale/jsonMessages';

const Login = ({ title, warning = false, refer, intl }) => {
  let initialValues = {}, socialLoginRefer, registerURL = '/register';

  if (refer) {
    initialValues = { refer };
    socialLoginRefer = refer;

    if (socialLoginRefer) {
      socialLoginRefer = socialLoginRefer.includes('?')
        ? socialLoginRefer.replaceAll('?', '------')
        : socialLoginRefer;
      socialLoginRefer = socialLoginRefer.includes('&')
        ? socialLoginRefer.replaceAll('&', '--')
        : socialLoginRefer;
    }
    registerURL = `/register?refer=${encodeURIComponent(refer)}`;

    socialLoginRefer = encodeURIComponent(socialLoginRefer)
  }

  return (
    <div className={s.root}>
      <div className={s.container}>
        {warning && (
          <div>
            <FormattedMessage {...messages.loginConfirmation} />
          </div>
        )}
        <LoginForm
          initialValues={initialValues}
          registerURL={registerURL}
          refer={socialLoginRefer}
        />
      </div>
    </div>
  );
};

Login.propTypes = {
  title: PropTypes.string.isRequired,
  warning: PropTypes.bool,
  refer: PropTypes.string,
  intl: PropTypes.object.isRequired, // Added for injectIntl
};

Login.defaultProps = {
  warning: false
};

export default injectIntl(withStyles(s, bt)(Login));